(function () {
  function readSettings() {
    return window.vatDisplaySettings || {};
  }

  function isDeMarket() {
    const cfg = readSettings();
    if (cfg.isDe) return true;
    if (document.body && document.body.classList.contains('is-de-market')) return true;
    return window.location.pathname.indexOf('/de/') !== -1;
  }

  function isEnabled() {
    return !!readSettings().enabled;
  }

  function getVatRate() {
    if (!isEnabled()) return 0;
    const cfg = readSettings();
    return isDeMarket() ? Number(cfg.rateDe || 19) : Number(cfg.rateGb || 20);
  }

  function applyVatCents(cents) {
    if (!isEnabled() || cents == null || isNaN(cents)) return cents;
    const rate = getVatRate();
    return Math.round(Number(cents) * (100 + rate) / 100);
  }

  function getMoneyFormat() {
    const cfg = readSettings();
    return (
      cfg.moneyFormat ||
      (window.theme && window.theme.moneyFormat) ||
      (typeof Shopify !== 'undefined' && Shopify.money_format) ||
      '{{amount}}'
    );
  }

  function formatMoney(cents) {
    const displayCents = applyVatCents(cents);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(displayCents, getMoneyFormat());
    }
    return (displayCents / 100).toFixed(2);
  }

  function getSuffix() {
    if (!isEnabled()) return '';
    return isDeMarket() ? '+Mwst' : '+VAT';
  }

  window.VatDisplay = {
    isEnabled,
    isDeMarket,
    getVatRate,
    applyVatCents,
    formatMoney,
    getSuffix,
  };
})();
